<div class="modal-body h-100 p-0">
  <div class="panel h-100">
    <div class="container-fluid h-100">
      <div class="row align-items-stretch h-100">
        <div
          class="col-auto settings-modal__nav py-5 py-lg-8 px-5 px-lg-8 h-100 overflow-auto"
        >
          <button
            type="button"
            class="link back-link text-primary"
            (click)="close()"
          >
            <div class="lottie">
              <ng-lottie
                [options]="options"
                (animationCreated)="animationCreated($event)"
              ></ng-lottie>
            </div>
            <span i18n="@@common_settingsMenu_backButton">Back</span>
          </button>
          <ul
            ngbNav
            #nav="ngbNav"
            [(activeId)]="active"
            class="nav nav-pills mt-7 p-0"
            orientation="vertical"
          >
            <li ngbNavItem="profile" class="fw-semi-bold">
              <a ngbNavLink><span class="text-uppercase"
                i18n="@@common_settingsMenu_profileLink">Profile</span></a>
              <ng-template ngbNavContent>
                <app-profile
                  [profile]="profile"
                  [settings]="true"
                ></app-profile>
              </ng-template>
            </li>
            <li ngbNavItem="account" class="fw-semi-bold">
              <a ngbNavLink><span class="text-uppercase"
                i18n="@@common_settingsMenu_accountLink">Account</span></a>
              <ng-template ngbNavContent>
                <app-account-edit></app-account-edit>
              </ng-template>
            </li>
            <li ngbNavItem="contact-pref" class="fw-semi-bold">
              <a ngbNavLink><span class="text-uppercase"
                i18n="@@common_settingsMenu_consentsLink">Consents</span></a>
              <ng-template ngbNavContent>
                <app-consents
                  [profile]="profile"
                  [settings]="true"
                ></app-consents>
              </ng-template>
            </li>
            <li ngbNavItem="help" class="fw-semi-bold">
              <a ngbNavLink
                ><span
                  class="text-uppercase"
                  i18n="@@common_settingsMenu_helpContactLink"
                  >Help & contact</span
                ></a
              >
              <ng-template ngbNavContent>
                <app-help></app-help>
              </ng-template>
            </li>
            <li ngbNavItem="legal" class="fw-semi-bold">
              <a ngbNavLink><span class="text-uppercase"
                i18n="@@common_settingsMenu_legalsLink">Legal notice</span></a>
              <ng-template ngbNavContent>
                <app-legal></app-legal>
              </ng-template>
            </li>
            <li ngbNavItem="delete" class="fw-semi-bold">
              <a ngbNavLink
                ><span class="text-uppercase"
                i18n="@@common_settingsMenu_deleteAccountLink">Delete account</span></a
              >
              <ng-template ngbNavContent>
                <app-delete-account
                  (deletedAccount)="close()"
                ></app-delete-account>
              </ng-template>
            </li>
          </ul>
        </div>
        <div
          class="col overflow-auto h-100 py-5 py-lg-8 px-lg-8 settings-modal__content"
          [ngbNavOutlet]="nav"
        ></div>
      </div>
    </div>
  </div>
</div>
